import React from 'react';
export const Spinner = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3'
  };

  return (
    <div
      className={`gpc-spinner ${sizes[size]} ${className}`}
      role="status"
      aria-label="Cargando"
    >
      <span className="sr-only">Cargando...</span>
    </div>
  );
};

export const TypingIndicator = () => {
  return (
    <div className="gpc-typing-indicator" role="status" aria-label="Escribiendo">
      <span className="gpc-typing-dot" />
      <span className="gpc-typing-dot" />
      <span className="gpc-typing-dot" />
    </div>
  );
};
